export default function getFirstAvailableCardId(offer) {
  const firstNonEmptySection = offer.sections.edges.find(
    sectionEdge => sectionEdge.node.cards.edges.length > 0
  );
  if (!firstNonEmptySection) {
    return '';
  }
  return firstNonEmptySection.node.cards.edges[0].node.pid;
}
